module.exports = __webpack_public_path__ + "assets/img/img-hotel-02.345a4644.jpg";